import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllDrugTypeManagementService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    let filter = {
      name: debouncedSearch,
      code: debouncedSearch,
      packageName: debouncedSearch,
      maxReturnablePillCount: debouncedSearch,
    };
    return axios.get(
      `${api}/DrugType/GetDrugTypePagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${JSON.stringify(filter)}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchPackageTypeData = async (access_token) => {
  try {
    return axios.get(`${api}/DrugType/GetPackageList`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchDrugTypeByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/DrugType/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const createDrugTypeService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DrugType/Create`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateDrugTypeService = async (access_token, data, id) => {
  try {
    return axios.post(`${api}/DrugType/Update?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
